const landing = {
    landingFooter: {
      legal: 'Legal',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      location: 'Location',
      address: 'Triple-Tower 30, Wolpyeongjung-ro, Seo-gu, Daejeon, Republic of Korea, 35223',
      email: 'Email',
      phone: 'Phone',
      businessHours: 'Business Hours: 9:00 AM - 6:00 PM KST (12:00 AM - 09:00 AM UTC)',
      lunch: 'Lunch Break: 11:30 AM - 1:00 PM KST (2:30 AM - 4:00 AM UTC)',
      closed: 'Closed on weekends and public holidays',
      bank: 'Bank Account Information',
      bankName: 'KOOKMIN BANK',
      accountNumber: '748301-01-604539',
    }
  };
  
  export default landing;